import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { SessionContext } from "../context/SessionContext";
import { ProfileContext } from "../context/ProfileContext";

const Logout = () => {
	const navigate = useNavigate();
	const [session, setSession] = useContext(SessionContext);
	const [, setProfile] = useContext(ProfileContext);

	const logout = async () => {
		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"X-Auth-Token": session,
			},
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/users/logout`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			console.log("Something went wrong.");
		} else {
			setSession(null);
			setProfile(null);
		}
	};

	useEffect(() => {
		logout();
	}, []);

	useEffect(() => {
		if (!session) {
			navigate("/admin/login");
		}
	}, [session]);

	return "";
};

export default Logout;
